import type { Locale } from 'date-fns/locale';
import { de, enGB, frCH, itCH } from 'date-fns/locale';

import { LOCALE } from '../../core/enums/locale.enum';

export const getDateFnsLocale = (language: LOCALE): Locale => {
  switch (language) {
    case LOCALE.ENGLISH:
      return enGB;
    case LOCALE.GERMAN:
      return de;
    case LOCALE.FRENCH:
      return frCH;
    case LOCALE.ITALIAN:
      return itCH;
  }
};
